import { StyleSheet, Font } from "@react-pdf/renderer";

import InterRegular from "../../../../assets/fonts/Inter-Regular.ttf";
import InterBold from "../../../../assets/fonts/Inter-Bold.ttf";
import InterExtraBold from "../../../../assets/fonts/Inter-ExtraBold.ttf";
import InterHeavy from "../../../../assets/fonts/Inter-Black.ttf";
import InterMedium from "../../../../assets/fonts/Inter-Medium.ttf";
import InterSemiBold from "../../../../assets/fonts/Inter-SemiBold.ttf";

// Register font
Font.register({
  family: "Inter",
  fonts: [
    {
      src: InterRegular,
    },
    {
      src: InterBold,
      fontWeight: "bold",
    },
    {
      src: InterExtraBold,
      fontWeight: "ultrabold",
    },
    {
      src: InterHeavy,
      fontWeight: "heavy",
    },
    {
      src: InterMedium,
      fontWeight: "medium",
    },
    {
      src: InterSemiBold,
      fontWeight: "semibold",
    },
  ],
});

export const styles = StyleSheet.create({
  document: {
    position: "relative",
    fontFamily: "Inter",
  },
  page: {
    backgroundColor: "white",
    paddingTop: 40,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  date: {
    position: "absolute",
    fontSize: 12,
    top: 24,
    right: 32,
    textAlign: "right",
    color: "grey",
  },
  builtBy: {
    position: "absolute",
    fontSize: 12,
    bottom: 32,
    left: 32,
    textAlign: "right",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 32,
    right: 32,
    textAlign: "right",
    color: "grey",
  },
  watermark: {
    position: "absolute",
    fontSize: 50,
    opacity: 0.15,
    color: "black",
    transform: "rotate(-45deg) translate(-125%, -100%)",
    top: "50%",
    left: "50%",
  },
  contactDetails: {
    display: "flex",
    flexDirection: "row",
    fontSize: 12,
  },
});
